import { ArrowPathIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { AiSummaryState } from "components/ai-summary/ai-summary-state";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface GenerateAiSummaryButtonProps {
    aiSummary: AiSummaryState;
    entityName: string;
}

export const GenerateAiSummaryButton: React.FC<GenerateAiSummaryButtonProps> = props => {
    const { aiSummary, entityName } = props;

    if (aiSummary.summary || aiSummary.isQueryLoading || !entityName) {
        return null;
    }

    return (
        <SecondaryCompactButton
            onClick={aiSummary.generate}
            disabled={aiSummary.isLoading}
            className="flex-shrink-0 items-center space-x-1">
            {aiSummary.isGenerating ? (
                <ArrowPathIcon aria-hidden="true" className="h-3.5 w-3.5 animate-spin" />
            ) : (
                <SparklesIcon aria-hidden="true" className="h-3.5 w-3.5" />
            )}
            <span>Generate AI summary</span>
        </SecondaryCompactButton>
    );
};
